var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F0F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.643 38.56C60.5406 33.6704 59.587 29.696 57.8398 27.2832C55.9646 23.168 48.643 16.5184 37.5646 18.7968C32.2526 19.8912 27.907 20.224 25.0014 20.2944C23.2094 20.3392 22.2046 22.3872 23.2734 23.8272C23.8558 24.608 24.547 25.4592 25.3598 26.336C23.107 28.5696 21.8782 32.9664 21.763 38.56C21.699 39.1872 21.667 39.8208 21.667 40.4608C21.667 51.2384 30.4286 60 41.2062 60C51.9774 60 60.7454 51.2384 60.7454 40.4608C60.739 39.8208 60.707 39.1872 60.643 38.56ZM41.2062 57.44C31.843 57.44 24.227 49.824 24.227 40.4608C24.227 39.3408 24.3358 38.2528 24.547 37.1968C27.9134 34.1312 30.0446 30.7648 30.0446 30.7648C30.0446 30.7648 30.0766 30.624 30.1086 30.3872C30.2302 30.464 30.339 30.5472 30.4606 30.6304C37.699 35.2576 48.6878 32.3968 52.611 31.136C53.251 32.0768 55.1518 34.7328 57.8654 37.2032C58.0702 38.2592 58.1854 39.3536 58.1854 40.4672C58.179 49.824 50.563 57.44 41.2062 57.44Z",
    fill: "#4F537B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1949 38.2208C31.0045 38.2208 30.0381 39.1872 30.0381 40.3776C30.0381 41.568 31.0045 42.5344 32.1949 42.5344C33.3853 42.5344 34.3517 41.568 34.3517 40.3776C34.3517 39.1872 33.3917 38.2208 32.1949 38.2208Z",
    fill: "#4F537B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2115 38.2208C49.0211 38.2208 48.0547 39.1872 48.0547 40.3776C48.0547 41.568 49.0211 42.5344 50.2115 42.5344C51.4019 42.5344 52.3683 41.568 52.3683 40.3776C52.3683 39.1872 51.4019 38.2208 50.2115 38.2208Z",
    fill: "#4F537B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.249 46.0159C45.6346 45.6831 44.8602 45.9135 44.5146 46.5151C44.4826 46.5791 43.625 48.0255 41.1994 48.0255C38.7994 48.0255 37.9354 46.6111 37.8842 46.5215C37.5514 45.9071 36.7898 45.6703 36.169 45.9967C35.5418 46.3231 35.2986 47.0975 35.625 47.7247C35.689 47.8399 37.1674 50.5919 41.1994 50.5919C45.2314 50.5919 46.7162 47.8463 46.7738 47.7247C47.1002 47.1039 46.8634 46.3487 46.249 46.0159Z",
    fill: "#4F537B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentMale);
export default __webpack_public_path__ + "static/media/StudentMale.1181b6661bb3a76e23c3ae7044391629.svg";
export { ForwardRef as ReactComponent };